import { InjectionToken } from "@angular/core";

export const BASE_URL = new InjectionToken<string>('BaseUrl');
export const CORE_API_URL = new InjectionToken<string>('CoreApiUrl');
export const AUTH_SCOPES = new InjectionToken<string[]>('AuthScopes');
export const DIARY_HUB_URL = new InjectionToken<string>('DiaryHubUrl');
export const EMAIL_TEMPLATE_HUB_URL = new InjectionToken<string>('EmailTemplateHubUrl');
export const EMAIL_HUB_URL = new InjectionToken<string>('EmailHubUrl');
export const MESSAGING_ENDPOINT = new InjectionToken<string>('MessagingEnvironmentConfig');
export const DOMAIN = new InjectionToken<string>('Domain');
export const MEDICAL_HUB_URL = new InjectionToken<string>('MedicalHubUrl');
export const SYSTEM_USER_ID = new InjectionToken<string>('SystemUserId');